module.exports = __webpack_public_path__ + "img/start3.4d01d94.png";